import type { ReactElement } from "react";
import { Link } from "react-router-dom";
import { UiIcon } from "./UiIcons";

type GuideCtaCategory = "newborn" | "baby" | "maternity" | "family";

const categoryLabels: Record<GuideCtaCategory, string> = {
  newborn: "Newborn",
  baby: "Baby",
  maternity: "Maternity",
  family: "Family",
};

interface GuideCtaActionsProps {
  category: GuideCtaCategory;
}

export const GuideCtaActions = ({ category }: GuideCtaActionsProps): ReactElement => (
  <div className="guide-cta-actions">
    <Link className="newborn-button newborn-button--coral" to={`/prices/${category}/`}>
      View {categoryLabels[category]} Packages &amp; Pricing <UiIcon name="arrow" />
    </Link>
    <Link className="guide-cta-actions__contact" to="/contact/">
      Already booked or have a question? Contact Alena
    </Link>
  </div>
);
